/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Per_YearInputs */

const en_pricing_per_year = /** @type {(inputs: Pricing_Per_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/year`)
};

const id_pricing_per_year = /** @type {(inputs: Pricing_Per_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/tahun`)
};

/**
* | output |
* | --- |
* | "/year" |
*
* @param {Pricing_Per_YearInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pricing_per_year = /** @type {((inputs?: Pricing_Per_YearInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Per_YearInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pricing_per_year(inputs)
	return en_pricing_per_year(inputs)
});